import { DateTime } from "luxon";

export default class AnalyticsService {
  async send() {
    try {
      if (!process.env.REACT_APP_ANALYTICS_ID) {
        console.warn("Missing analytics ID");
        return; // early return, no point continuing
      }

      const timestamp = DateTime.utc()
        .setZone("Australia/Sydney")
        .toFormat("yyyy-MM-dd HH:mm:ss");

      const payload = {
        timestamp,
        title: document.title,
        url: globalThis.location.href,
        referrer: document.referrer,
        // User agent is still useful for device type, but Brave/Firefox spoof it
        user_agent: navigator.userAgent,
        event_name: "pageview",
        topic: "web_analytics",
        site_id: process.env.REACT_APP_ANALYTICS_ID,
        // Send screen/viewport for device inference instead of relying on UA alone
        screen: `${window.screen.width}x${window.screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
      };

      // Use sendBeacon where available — it survives page unload,
      // and is less likely to be blocked than a plain fetch POST
      const endpoint = "/sitelets/api/analytics/pageview"; // proxy through your OWN domain, not collector directly
      const blob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
      });

      const beaconSent = navigator.sendBeacon?.(endpoint, blob);

      if (!beaconSent) {
        // Fallback to fetch with keepalive
        await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "sitelet-guid": process.env.REACT_APP_SITELET_GUID ?? "",
          },
          body: JSON.stringify(payload),
          keepalive: true,
          credentials: "include",
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
}
